// @ts-nocheck
import { createOrderSlice } from 'pages/orderShared/createOrderSlice';

const { slice, initialState: _initialState } = createOrderSlice({
	name: 'orderByKit',
	columnKeys: ['kit', 'store', 'warehouse', 'order'],
	hasAvailability: true,
});

export const initialState = _initialState;
export default slice;

export const { setColumns, setOrderData, appendOrderData, setAvailability, setLoading, clearData } = slice.actions;
